import { useCallback, useEffect } from "react";

import { Download } from "@mui/icons-material";
import { DocumentItem } from "@covertree/ui/content/DocumentItem";
import Toast from "@covertree/utils/Toast";

import { CoverageDocument } from "@graphql/api";

import { useLazyGetDocumentUrlQuery } from "@redux/documents/documentsApi";

interface Props {
  document: CoverageDocument;
  residentId: string;
}

export default function Document({ document, residentId }: Props) {
  const [getDocumentUrl, { data, isFetching, error, isError }] =
    useLazyGetDocumentUrlQuery();

  const onDocumentDownload = useCallback(() => {
    getDocumentUrl({ residentId, id: document.id });
  }, [document.id, getDocumentUrl, residentId]);

  useEffect(() => {
    if (!isFetching && !isError && data) {
      window.open(data, "_blank");
    }
  }, [isError, isFetching, data]);

  useEffect(() => {
    if (isError && error) {
      Toast.showError(error);
    }
  }, [isError, error]);

  return (
    <DocumentItem
      name={document.name}
      description={document.description}
      actions={[
        {
          name: "Download",
          isLoading: isFetching,
          onClick: onDocumentDownload,
          icon: <Download />,
        },
      ]}
    />
  );
}
